import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus_mini_s",
  "use": "plus_mini_s-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"plus_mini_s\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.889 7H8.11C7.5 7 7 7.5 7 8.111v7.778C7 16.5 7.5 17 8.111 17h7.778C16.5 17 17 16.5 17 15.889V8.11C17 7.5 16.5 7 15.889 7zM15 12.6h-2.4V15h-1.2v-2.4H9v-1.2h2.4V9h1.2v2.4H15v1.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol